// API base URL — read from environment variable REACT_APP_API_URL.
// Set this in your .env file (local) or Render dashboard (production).
// Falls back to production URL if not set.
const API_URL = process.env.REACT_APP_API_URL || 'https://api.turfx.co.in/api';

export { API_URL };
export default API_URL;
